<template>
    <div class="center w-full h-full pl-0 pr-0 overflow-hidden mb-5">
		<div class="flex flex-column w-full h-full justify-content-start align-items-center
            gap-5 xl:gap-7 lg:gap-6 md:gap-5">

            <Page :header="(!isPWA && !isTgApp) ? header[lang_].name : null">
                <template v-slot:body>
                    <div class="flex w-full max-w-30rem">
                        <TransferFilter v-if="isAuth" /> 
                    </div>
                </template>
            </Page> 

            <div class="w-full flex
                flex-column xl:flex-row lg:flex-row md:flex-row
                px-3 xl:px-4 lg:px-3 md:px-4 sm:px-3
                gap-4 xl:gap-7 lg:gap-6 md:gap-5">

                <!--LIST-->
                <div class="w-full flex flex-column gap-3">
                    <span class="w-full flex flex-row">
                        <div class="flex flex-1 align-items-center justify-content-start">
                            <span class="flex font-medium text-900 h-2rem
                                text-xl xl:text-2xl lg:text-xl md:text-xl">
                                {{ content[lang_].transfers }}
                            </span>
                        </div>
                        <div class="flex">
                            <Button :label="content[lang_].btnTransfers" @click="toTransfers()" size="small" severity="secondary"
                                class="flex surface-0 text-xs" icon="pi pi-arrow-right" iconPos="right" rounded />
                        </div>
                    </span>
                    <Transfers :count="1" :showNav="false"/>

                    <span v-if="!userTelegram" class="w-full flex flex-column">
                        <div class="flex flex-1 align-items-center justify-content-start">
                            <span class="flex font-medium text-900 h-2rem
                                text-lg xl:text-xl">
                                {{ content[lang_].notifications }}
                            </span>
                        </div>
                        <Telegram />
                    </span>
                </div>

                <!--FAQ-->
                <div class="w-full flex flex-column mb-3 
                    gap-4 xl:gap-6 lg:gap-5">
                    <div class="w-full flex flex-column">
                        <div class="w-full flex flex-row mb-3">
                            <div class="flex flex-1 align-items-center">
                                <span class="flex font-medium text-900 h-2rem
                                    text-xl xl:text-2xl lg:text-xl md:text-xl">
                                    {{ content[lang_].faq }}
                                </span>
                            </div>
                            <div class="flex">
                                <Button :label="content[lang_].btnFaq" @click="toFaq()" size="small" severity="secondary"
                                    class="flex surface-0 text-xs" icon="pi pi-arrow-right" iconPos="right" rounded />
                            </div>
                        </div>
                        <div class="w-full flex">
                            <FaqShortList v-if="tabs" :tabs="tabs" :count="4" />
                        </div>
                    </div>
                </div>
            </div>
		</div>
    </div>
</template>

<script>
import TransferFilter from '@/components/widgets/TransferFilter.vue' 
import Page from '@/components/sides/Page.vue' 
import Transfers    from '@/components/personal/transfer/List.vue' 
import FaqShortList     from '@/components/widgets/FaqList.vue'
import Telegram from         '@/components/personal/profile/Telegram.vue'
import { mapActions } from 'vuex'

export default {
    data() {
		return {
			header: {
                en: {name: "Create a transfer"} ,
                ru: {name: "Создать перевод"} ,
            }, 
            content: {
                ru: { 
                    notifications: "Настройте уведомления о переводах",
                    transfers: "Мои переводы",
                    btnTransfers: "Все переводы",
                    faq: "Вопрос-ответ",
                    btnFaq: "Все вопросы",
                },
                en: { 
                    notifications: 'Notifications about transfers',
                    transfers: "My transfers",
                    btnTransfers: "All transfers",
                    faq: "FAQ",
                    btnFaq: "All questions",
                }
            },
            tabs: [
                {
                    ru: {
                        title: "Что если нет нужного банка приема?",
                        content: "Если в списке банков приема нет нужного вам банка, то вы можете выбрать любой другой банк, на который вам удобно отправить средства. А так же вы можете выбрать способ 'Любой другой банк'"
                    },
                    en: {
                        title: "What if the desired receiving bank is not on the list?",
                        content: "If the desired receiving bank is not on the list, you can choose any other bank that is convenient for you to send funds to. You can also select the 'Any other bank' option."
                    }
                },
                {
                    ru: {
                        title: "Что если нет нужного способа выплаты?",
                        content: "Если в списке способов выплаты нет нужного вам способа, то оставьте заявку 'Под запрос' и мы постараемся его добавить."
                    },
                    en: {
                        title: "What if the desired payment method is not on the list?",
                        content: "If the desired payment method is not on the list, please leave a request 'Upon request' and we will try to add it."
                    }
                },
                {
                    ru: {
                        title: "Кто такой Получатель?",
                        content: "Получатель - это человек, которому вы отправляете деньги. Укажите реквизиты один раз и в следующий раз вы сможете выбрать его из списка."
                    },
                    en: {
                        title: "Who is the Recipient?",
                        content: "The Recipient is the person to whom you are sending money. Specify the details once and next time you will be able to select them from the list."
                    }
                },
                {
                    ru: {
                        title: "Обязательно ли должно совпадать имя Получателя и Отправителя?",
                        content: "Нет, но желательно чтобы вы отправляли средства с личных карт. При этом имя в профиле должно совпадать с именем на карте, иначе мы будем вынуждены запросить проверку."
                    },
                    en: {
                        title: "Does the name of the Recipient and Sender have to match?",
                        content: "No, but it is preferable that you send funds from personal cards. In this case, the name in the profile should match the name on the card, otherwise we will be forced to request verification."
                    }
                },
            ],
		}
	},
    components: {
        TransferFilter,
        Page,
        Transfers,
        FaqShortList,
        Telegram
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },	
        isAuth: function () { return this.$store.getters.isAuthenticated },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
        userTelegram: function () { return this.$store.getters.StateTelegramUsername },
	},
    methods: {
        ...mapActions(['ActionGetAllWallets', 'SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        toTransfers() {
            this.$router.push('/personal/transfers/')
        },
        toFaq() {
            this.$router.push('/support/faq/')
        }
    },
    mounted() {
        try {
            this.SetHeaderTitle(null)
            this.SetHeaderBtnLeftFirst({
                type: 'avatar',
                link: '/personal/profile/',
                icon: 'pi pi-user',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                type: 'action',
                action: 'invite',
                label: 'Пригласить',
                icon: 'pi pi-gift',
                iconPos: 'right',
                severity: 'primary',
                class: 'text-green-500',
                rounded: true,
                visible: true
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    }
}
</script>
